import React, { useEffect, useState } from 'react';
import Title from 'components/UI/Title';
import Checkbox from 'components/UI/Checkbox';
import CounterBox from 'components/UI/CounterBox';
import { useCountersHandlers } from '../../../hooks';
import * as styles from './counter.module.scss';

function MobileItem({ value, title, onChangeCount }) {
  const [active, setActive] = useState(false);
  const { increment, decrement } = useCountersHandlers(onChangeCount);

  useEffect(() => {
    setActive(Boolean(value));
  }, [Boolean(value)]);

  const toggleCounterHandler = () => {
    setActive(!active);
    onChangeCount(title, !active ? 1 : 0);
  };

  return (
    <li className={styles.item}>
      <Checkbox name={title} checked={active} onChange={toggleCounterHandler}>
        <Title tag="p" size="h3" className={styles.itemTitle}>
          {title}
        </Title>
      </Checkbox>
      {active && (
        <CounterBox
          theme="rightSide"
          value={value}
          increment={() => increment(title, value)}
          decrement={() => decrement(title, value)}
        />
      )}
    </li>
  );
}

export default React.memo(MobileItem);
